/** @format */

const template = `
<span class="text-with-default-missing-value text-area-static" ng-class="{missing: !$ctrl.hasValue}"
  >{{$ctrl.renderedValue || $ctrl.missingValue}}</span
>
`;
export default template;
